module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"saveContact":"Save contact","workEmail":"Work email","addANote":"Add a note","company":"Company","showAllFields":"Show more fields","formError":"Something appears to be wrong, and we can\u0027t add this contact right now. Please try again in a minute."}}')
  delete Component.options._Ctor
}
